import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { Table, Layout, Space, Row, Col, Button, Tooltip } from 'antd'
import {
  StopOutlined,
  EditOutlined,
  MailOutlined,
  DeleteOutlined,
  CheckCircleOutlined
} from "@ant-design/icons"

import usePaginate from '../../firebase/hooks/usePaginate'
// import { useStore } from "../../contexts/FireStoreContext"
import FireStoreSearch from "../../components/FilterSearch"
import { useAuth } from "../../contexts/AuthContext"
import PageLimitDropDown from "../../components/PageLimitDropDown"
import useUsers from "../../firebase/hooks/useUsers"

const { Content } = Layout

const table = "users"
const where = ['role', '==', 'user']

const searchOptions = [
  {
    'key': 'firstName',
    'label': 'First Name'
  },
  {
    'key': 'lastName',
    'label': 'Last Name'
  },
  {
    'key': 'email',
    'label': 'Email'
  }
]

const Users = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  // const { deleteDocument } = useStore()
  const { user } = useAuth()
  const [list, setList] = useState([])
  const [showMore, setShowMore] = useState(true)
  const { approveUser, blockUser, deleteConfirm, resetUserPassword } = useUsers()

  const {
    loading,
    loadingMore,
    hasMore,
    items,
    loadMore
  } = usePaginate(table, {
    where: where,
    // where: ["firstName", "==", 'John'],
    // orderBy: ["bank", "asc"],
    limit: user.limit
  })

  useEffect(() => {
    setList(items)
  }, [items])

  console.log(list)

  const setResult = async (list, searchLength) => {
    if (searchLength > 1) {
      setList(list)
      setShowMore(false)
    } else {
      setList(items)
      setShowMore(true)
    }
  }

  const columns = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.firstName.length - b.firstName.length,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.lastName.length - b.lastName.length,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.email.length - b.email.length,
      sortDirections: ['ascend', 'descend']
    },
    // {
    //   title: 'Type',
    //   dataIndex: 'type',
    //   key: 'type',
    //   // sorter: true,
    //   sorter: (a, b) => a.type.length - b.type.length,
    //   sortDirections: ['ascend', 'descend'],
    //   render: (type) => <span>{type}</span>
    // },
    // {
    //   title: 'Countries',
    //   dataIndex: 'country',
    //   key: 'country',
    //   // sorter: true,
    //   sorter: (a, b) => a.country.length - b.country.length,
    //   sortDirections: ['ascend', 'descend'],
    //   render: (country, row) => <span>{country} ({row.iso2}) </span>
    // },
    // {
    //   title: 'Date',
    //   dataIndex: 'createdAt',
    //   key: 'createdAt',
    //   render: createdAt => (createdAt.toDate())
    // },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (id, row) => (
        <Space size="middle">
          {/* https://firebase.google.com/docs/auth/admin/manage-users#update_a_user */}
          {false &&
            <Tooltip title="Edit">
              <EditOutlined onClick={() => history.push(`${pathname}/edit/${id}`, row)} />
            </Tooltip>
          }
          {(row.status === 'p' || row.status === 'b') &&
            <Tooltip title="Approve">
              <CheckCircleOutlined onClick={() => approveUser(id)} style={{ color: "#00ff00" }} />
            </Tooltip>
          }
          {row.status === 'a' &&
            <Tooltip title="Block">
              <StopOutlined onClick={() => blockUser(id)} style={{ color: "#ff0000" }} />
            </Tooltip>
          }
          <Tooltip title="Reset Password">
            <MailOutlined style={{ color: "#000" }} onClick={() => resetUserPassword(row)} />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined style={{ color: "#ff0000" }} onClick={() => deleteConfirm(row)} />
          </Tooltip>
        </Space>
      )
    }
  ]

  const onChange = (data) => {
    console.log(data)
  }

  return (
    <Content>
      {/* <Breadcrumb>
        <Breadcrumb.Item>Banks</Breadcrumb.Item>
      </Breadcrumb> */}
      <div className="" style={{ padding: 16, minHeight: 360 }}>
        <Row justify="space-between">
          <Col xs={18} lg={6}>
            <FireStoreSearch table={table} searchOptions={searchOptions} setResult={setResult} />
          </Col>
          <Col xs={6} lg={18} className="text-right"></Col>
        </Row>
        <Table
          rowKey="id"
          dataSource={list}
          columns={columns}
          loading={loading}
          onChange={onChange}
          pagination={false}
        />
        <Row justify="space-between" style={{ marginTop: "1.5em" }}>
          <Col>
            <PageLimitDropDown />
          </Col>
          <Col>
            {showMore && hasMore && !loadingMore && <Button type="primary" onClick={loadMore}>Load More</Button>}
            {loadingMore && <Button type="primary" loading>Loading...</Button>}
          </Col>
        </Row>
      </div>
    </Content>
  )
}

export default Users
